import { useState } from "react";
import AddToDriveIcon from "@mui/icons-material/AddToDrive";
import {
  ALL_COPIES_OF_PLATFORM,
  COPIES_OF_AD,
  EXPORT_COPIES_TO_GOOGLE_DRIVE,
} from "../../i18n/keysTranslations";
import ButtonMenu from "./ButtonMenu";
import { startExportCopiesToGoogleDrive } from "../../actions/adsCampaigns";
import { useDispatchApp } from "../../lib/redux";
import { openLink } from "../../utils/string";
import Loader from "../Loaders/Loader";
import { useTranslationApp } from "../../lib/i18next";

const IconButtonExportCopies = ({
  campaignID,
  platform,
  assetGroupID,
  adID,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatchApp();
  const { t } = useTranslationApp();

  const onExportCopies = async (from) => {
    const data = {
      campaignID,
      platform,
    };

    if (from === "ad") {
      data.assetGroupID = assetGroupID;
      data.adID = adID;
    }

    setIsLoading(true);
    const response = await dispatch(startExportCopiesToGoogleDrive(data));
    if (response.ok) {
      openLink(response.data.url);
    }
    setIsLoading(false);
  };

  return (
    <>
      {!isLoading && (
        <ButtonMenu
          mode="icon"
          tooltipText={t(EXPORT_COPIES_TO_GOOGLE_DRIVE)}
          iconButton={<AddToDriveIcon />}
          options={[
            {
              label: COPIES_OF_AD,
              onClick: () => onExportCopies("ad"),
            },
            {
              label: ALL_COPIES_OF_PLATFORM,
              onClick: () => onExportCopies("platform"),
              extrapolation: {
                platform: t(platform),
              },
            },
          ]}
        />
      )}

      {isLoading && (
        <Loader
          size={25}
          hasMarginTop={false}
          sx={{
            ml: 1,
          }}
        />
      )}
    </>
  );
};

export default IconButtonExportCopies;
